/* eslint-disable import/exports-last */
/* eslint-disable import/prefer-default-export */
export function toLowerCase(str) {
    return str.toLowerCase();
}
export function toUpperCase(str) {
    return str.toUpperCase();
}
export function capitalize(str) {
    return (str.charAt(0).toUpperCase() + str.slice(1));
}
export function toSnakeCase(str) {
    return str
        .replace(/([A-Z]{2,})/g, (letter) => letter.toLowerCase())
        .replace(/(\s[A-Za-z])/g, (group) => group.toLowerCase().replace(/[\s]/, '_'))
        .replace(/[A-Z]/g, (letter, index) => {
        return index == 0 ? letter.toLowerCase() : '_' + letter.toLowerCase();
    });
}
export function toCamelCase(str) {
    return str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace(/[-_]/, ''));
}
/**
 *
 * @returns a replacer function that can be used as the second argument of JSON.stringify to handle circular references
 */
function getCircularReplacer() {
    const seen = new WeakSet();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (_key, value) => {
        if (typeof Node === 'function' && value instanceof Node) {
            return;
        }
        if (typeof value === 'object' && value !== null) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            if (seen.has(value)) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            seen.add(value);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value;
    };
}
/**
 * Serializes data to a JSON string, handling the case where values are circular references
 * @param data anything
 * @param indent JSON.stringify indentation
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stringify(data, indent = 2) {
    return JSON.stringify(data, getCircularReplacer(), indent);
}
//# sourceMappingURL=string.js.map